import Vue from "vue";
import moment from "moment";

Vue.filter("formatNumber", function(val) {
    if (val === null || val === undefined) {
        return "";
    }
    if (typeof val === "number") {
        return val.toLocaleString("en-US");
    }
    // console.log("Filter formatNumber not number " + val);
    return val;
});

Vue.filter("formatFloat", function(val) {
    if (val === null || val === undefined) {
        return "";
    }
    if (typeof val !== "number") {
        val = parseFloat(val);
    }
    const fixed = 5;
    var decimalPart;

    var array = Math.floor(val)
        .toString()
        .split("");
    var index = -3;
    while (array.length + index > 0) {
        array.splice(index, 0, ",");
        index -= 4;
    }

    if (fixed > 0) {
        decimalPart = val.toFixed(fixed).split(".")[1];
        return array.join("") + "." + decimalPart;
    }
    return array.join("");
});

Vue.filter("formatDate", function(val) {
    if (val === null || val === undefined) {
        return "";
    }
    let tmp = moment(val);
    if (tmp.isValid()) {
        return tmp.format("YYYY-MM-DD hh:mm A");
    }
});

var UNITS = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
var STEP = 1024;

function format(value, power) {
    return (value / Math.pow(STEP, power)).toFixed(2) + UNITS[power];
}

Vue.filter("smartFileSize", function(value) {
    value = parseFloat(value, 10);
    for (var i = 0; i < UNITS.length; i++) {
        if (value < Math.pow(STEP, i)) {
            if (UNITS[i - 1]) {
                return format(value, i - 1);
            }
            return value + UNITS[i];
        }
    }
    return format(value, i - 1);
});
